import { Fragment } from "react";

function inline(text) {
  return text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((part, i) => {
    if (part.startsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.length > 2) return <em key={i}>{part.slice(1, -1)}</em>;
    return <Fragment key={i}>{part}</Fragment>;
  });
}

// Minimal markdown: "## " headings, "- " lists, paragraphs, **bold**, *italic*.
export default function Markdown({ content }) {
  // Split on blank lines, and also break a "## heading" line away from text that follows it on the next line.
  const blocks = (content || "").split(/\n\s*\n/).flatMap((b) => {
    const t = b.trim();
    if (!t.startsWith("## ")) return [t];
    const nl = t.indexOf("\n");
    return nl < 0 ? [t] : [t.slice(0, nl), t.slice(nl + 1)];
  }).filter((b) => b.trim());
  return (
    <div className="prose-q">
      {blocks.map((b, i) => {
        const t = b.trim();
        if (t.startsWith("## ")) return <h2 key={i}>{inline(t.slice(3))}</h2>;
        if (t.split("\n").every((l) => l.trim().startsWith("- ")))
          return <ul key={i}>{t.split("\n").map((l, j) => <li key={j}>{inline(l.trim().slice(2))}</li>)}</ul>;
        return <p key={i}>{inline(t)}</p>;
      })}
    </div>
  );
}
